export default __webpack_public_path__ + "static/media/Haylo-for-white-background.e7d9bf17.png";